import React from 'react'
import { FormState, UseFormRegister } from 'react-hook-form'

import MwFormLabel from '@/components/common/form/MwFormLabel'
import MwInput from '@/components/common/form/MwInput'
import MwSelect from '@/components/common/form/MwSelect'
import MwTextarea from '@/components/common/form/MwTextarea'
import prefs from '@/utils/addressPref'
import { EMAIL_REGEX, TEL_REGEX } from '@/utils/validateRegex'

import { ContactParams, ContactTypes } from './ContactContainer'

type ContactCompanyFormProps = {
  register: UseFormRegister<ContactParams>
  formState: FormState<ContactParams>
}

const ContactCompanyForm: React.FC<ContactCompanyFormProps> = ({ register, formState }) => {
  const { errors } = formState
  return (
    <>
      <MwFormLabel label="お問い合わせ種別">
        <MwSelect
          list={ContactTypes}
          error={errors.otoiawasesyubetsu_atsougi}
          register={register('otoiawasesyubetsu_atsougi', {
            required: {
              value: true,
              message: '必須入力項目です',
            },
          })}
        />
      </MwFormLabel>
      <MwFormLabel label="店名・企業名">
        <MwInput
          register={register('company', {
            required: {
              value: true,
              message: '必須入力項目です',
            },
          })}
          placeholder="例：〇〇葬儀社"
        />
      </MwFormLabel>
      <MwFormLabel label="ご担当者様名">
        <div className="pc:w-1/2 pc:mr-4 sp:mb-4">
          <MwInput
            register={register('firstname', {
              required: {
                value: true,
                message: '必須入力項目です',
              },
            })}
            placeholder="例：セイ"
            error={errors.firstname}
          />
        </div>
        <div className="pc:w-1/2">
          <MwInput
            register={register('lastname', {
              required: {
                value: true,
                message: '必須入力項目です',
              },
            })}
            placeholder="例：メイ"
            error={errors.lastname}
          />
        </div>
      </MwFormLabel>
      <MwFormLabel label="メールアドレス">
        <MwInput
          register={register('email', {
            required: {
              value: true,
              message: '必須入力項目です',
            },
            pattern: {
              value: EMAIL_REGEX,
              message: 'メールアドレスの形式を満たしていません',
            },
          })}
          error={errors.email}
          placeholder="例）"
        />
      </MwFormLabel>
      <MwFormLabel label="お電話番号" required={false}>
        <MwInput
          register={register('phone', {
            pattern: {
              value: TEL_REGEX,
              message: '電話番号の形式を満たしていません',
            },
          })}
          error={errors.phone}
          placeholder="例：03-1234-5678"
        />
      </MwFormLabel>
      <MwFormLabel label="エリア">
        <MwSelect
          list={prefs}
          register={register('syozaichi', {
            required: {
              value: true,
              message: '必須入力項目です',
            },
          })}
          error={errors.syozaichi}
        />
      </MwFormLabel>
      <MwFormLabel label="お問い合わせ内容">
        <MwTextarea
          register={register('toiawasenaiyou', {
            required: {
              value: true,
              message: '必須入力項目です',
            },
          })}
          placeholder="ご記入してください"
        />
      </MwFormLabel>
    </>
  )
}

export default ContactCompanyForm
